export const constructConfiguration = data => {
  if (!data) return null;

  return data;
};
